import session from './session';


const TIMEOUT_MS = 200000;


export default {
  getAvailableSuppliers() {
    return session.get('/api/ordering/available_suppliers', { timeout: 5000 });
  },
  getReportTemplate(supplier, orderPeriod, year, month) {
    return session.get('/api/ordering/report_template', { timeout: TIMEOUT_MS, params: { supplier, orderPeriod, year, month } });
  },
  getReport(reportEntityId) {
    return session.get(`/api/ordering/report/${reportEntityId}/data`, { timeout: TIMEOUT_MS });
  },
  saveReport(reportEntityId, changes) {    
    return session.post(`/api/ordering/report/${reportEntityId}`, {changes}, {timeout: TIMEOUT_MS});
  },
};



// WEBPACK FOOTER //
// ./src/api/ordering.js